import React, { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import Loading from "../../../../ui/atoms/loading/Loading";
import { wait } from "../../../../core/utils/helpers";

const ChallengeThemeContainer = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      await wait(1500);

      setIsLoading(false);
    };

    fetchData();
  }, []);

  return (
    <div className="w-full h-full">
      {isLoading ? <Loading type={"type-2"} /> : <Outlet />}
    </div>
  );
};

export default ChallengeThemeContainer;
